import common from "../../common";
import QuestionModel from "../../maths/QuestionModel";
import QuestionValuePercentage from "../../maths/QuestionValuePercentage";
import QuestionView from "./QuestionView";
import converter from "../../../libs/number-to-words";

export default class QuestionViewVerbal extends QuestionView {
    constructor(question) {
        super(question);

        this._template = null;

        this._confirmButton.x = this._footer.x + 400;

        if (this._inputField != null)
        {
            this._inputField.position.set(0, 0);
            this._footer.addChild(this._inputField);
        }
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const split = this._question.template.split("/");
        let templates = data.templates[split[0]][split[1]];

        //if we didn't define whether or not to use words, then pick randomly
        if (this._question.useWords === undefined) this._question.useWords = P3.math.randomBool();

        if (templates && templates.length > 0)
            templates = templates.slice().filter(x => this.filterTemplate(x));

        if (!templates || !templates.length) return "ERROR: NO TEMPLATE FOUND";

        this._template = P3.utils.selectRandom(templates);
        const words = data.words;

        let text = this._template ? this._template.text : "";
        if (this._template) {
            const names = this.generateWords(this._template.text, words.names, /\[NAME([0-9])?]/g);
            for (const i in names) {
                if (names.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), names[i]);
                }
            }

            let items = this.generateWords(this._template.text, words.items, /\[ITEM([0-9])?]/g);
            for (const i in items) {
                if (items.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), items[i]);
                }
            }

            let verbs2 = this.generateWords(this._template.text, words.verb_2, /\[VERB_TWO([0-9])?]/g);
            for (const i in verbs2) {
                if (verbs2.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), verbs2[i]);
                }
            }

            let verbs = this.generateWords(this._template.text, words.verb, /\[VERB([0-9])?]/g);
            for (const i in verbs) {
                if (verbs.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), verbs[i]);
                }
            }

            let char = this.generateWords(this._template.text, words.character_class, /\[CHARACTER_CLASS([0-9])?]/g);
            for (const i in char) {
                if (char.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), char[i]);
                }
            }

            let char_2 = this.generateWords(this._template.text, words.character_class_2, /\[CHARACTER_CLASS_TWO([0-9])?]/g);
            for (const i in char_2) {
                if (char_2.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), char_2[i]);
                }
            }

            const defenceitem = this.generateWords(this._template.text, words.defenceitem, /\[DEFENCE([0-9])?]/g);
            for (const i in defenceitem) {
                if (defenceitem.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), defenceitem[i]);
                }
            }

            const currency = this.generateWords(this._template.text, words.currency, /\[CURRENCY([0-9])?]/g);
            for (const i in currency) {
                if (currency.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), currency[i]);
                }
            }

            const itemPairs = this.generateWords(this._template.text, words.item_pairs, /\[ITEM_PAIR([0-9])?]/g);
            for (const i in itemPairs) {
                if (itemPairs.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i)), itemPairs[i][0]);//replace first instance
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), itemPairs[i][1]);//replace the rest
                }
            }

            const enemies = this.generateWords(this._template.text, words.enemies, /\[ENEMY([0-9])?]/g);
            for (const i in enemies) {
                if (enemies.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), enemies[i]);
                }
            }

            let locations = this.generateWords(this._template.text, words.locations, /\[LOCATION([0-9])?]/g);
            for (const i in locations) {
                if (locations.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), locations[i]);
                }
            }

            locations = this.generateWords(this._template.text, words.specific_locations, /\[SPECIFIC_LOCATION([0-9])?]/g);
            for (const i in locations) {
                if (locations.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), locations[i]);
                }
            }

            const values = this.generateValues(this._template.text, /\[VALUE([0-9])?]/g);
            for (const i in values) {
                if (values.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), values[i]);
                }
            }

            //TODO - not sure where this came from.  I find it hard to understand and it is generating numbers here? this doesn't seem right - ob
            /*
            //it used this template in multiplication_keypad
         {
           "text": "You are told that there are [RANDINRANGE] armies of [VALUE1] [ENEMY] each. How many [ENEMY] would be in [VALUE0] armies?",
           "part": 2,
           "values": 3
         }
             const rands = this._template.text.match(/\[RANDINRANGE?]/g);
             if(rands){
                 let valArr = [];
                 for(let i = this._question.range.min; i <= this._question.range.max; i++){
                     let addToArr = true;
                     for(let j in values){
                         if(values[j] === i) addToArr = false;
                     }
                     if(addToArr) valArr.push(i);
                 }
                 const randVal = valArr[P3.math.randomInt(0, valArr.length-1)];
                 for (const i in rands) {
                     text = text.replace(new RegExp(P3.utils.escape('[RANDINRANGE]'), "g"), randVal);
                 }
             }
             console.log(rands);
             */
            let places = this.generateWords(this._template.text, words.places, /\[PLACE([0-9])?]/g);
            for (const i in places) {
                if (places.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), places[i]);
                }
            }

            const activites = this.generateWords(this._template.text, words.character_activities, /\[CHARACTER_ACTIVITIES([0-9])?]/g);
            if (activites) {
                for (const i in activites) {
                    if (activites.hasOwnProperty(i)) {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), activites[i]);
                    }
                }
            }

            const specificActivites = this.generateWords(this._template.text, words.specific_activities, /\[SPECIFIC_ACTIVITIES([0-9])?]/g);
            if (specificActivites) {
                for (const i in specificActivites) {
                    if (specificActivites.hasOwnProperty(i)) {
                        text = text.replace(new RegExp(P3.utils.escape(i), "g"), specificActivites[i]);
                    }
                }
            }

            const liquidItems = this.generateWords(this._template.text, words.carry_items_liquid, /\[CARRY_ITEM_LIQUID([0-9])?]/g);
            for (const i in liquidItems) {
                if (liquidItems.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), liquidItems[i]);
                }
            }

            const liquids = this.generateWords(this._template.text, words.item_measurement.liquid, /\[LIQUID([0-9])?]/g);
            for (const i in liquids) {
                if (liquids.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), liquids[i]);
                }
            }

            const match = text.match(/\. [a-z]/g);
            if (match) {
                for (let i = 0; i < match.length; ++i) {
                    const s = match[i];
                    text = text.replace(new RegExp(P3.utils.escape(s), "g"), s.toUpperCase());
                }
            }
        }
        return text.charAt(0).toUpperCase() + text.slice(1);//capitalise first char
    }

    generateWords(text, options, regex) {
        const words = {};
        options = options.slice();

        let result = text.match(regex);
        if (result) {
            for (let i = 0; i < result.length; ++i) {
                const t = result[i];
                const name = P3.utils.selectRandom(options);
                !words[t] && (words[t] = name);
                options.splice(options.indexOf(name), 1);
            }
        }
        return words;
    }

    generateValues(text, regex) {
        const values = {};

        let result = text.match(regex);
        if (result) {
            for (let i = 0; i < result.length; ++i) {
                const t = result[i];
                const match = t.match(/[0-9]/);
                const index = match ? parseInt(match[0]) : 0;

                const value = this._question.values[index];
                values[t] = value.toString();
                /*
                //no longer want numbers to words at all
                if (value instanceof QuestionValuePercentage) {
                    values[t] = value.toString();
                } else {
                    values[t] = this._question.useWords ? converter.toWords(value.value) : value.toString();
                }
                */
            }
        }
        return values;
    }

    filterTemplate(x) {
        return x.part === this._question.part && x.values === this._question.values.length &&
            (x.useWords !== undefined ? x.useWords === this._question.useWords : true);
    }

    get template() {
        return this._template;
    }
}